import Model from './model.js'
import moment from 'moment'
import { toNormalised } from 'postcode'
import Contact from '~/models/contact.js'
import Call from '~/models/call.js'

export default class Lead extends Model {
	static _routeKey = 'lead'

	static _attributes = {
		origin_id: null,
		first_name: '',
		last_name: '',
		email: '',
		phone_number: '',
		address_line_1: '',
		address_line_2: '',
		town: '',
		postcode: '',
		title: '',
		description: '',
		source_id: null
	}

	_constructor() {
		this.type = 100

		if (this.contact != null) {
			this.contact = new Contact(this.contact)
		}

		if (this.call != null) {
			this.call = new Call(this.call, {
				vue: this.vue,
				timelineOrigin: this.timelineOrigin,
			})
		}
	}

	getAi(key) {
		if (this[key] != null && this[key] != '') {
			return this[key]
		}

		if (this.call != null 
			&& this.call.ai != null 
			&& this.call.ai.body 
			&& this.call.ai.body[key] != null 
			&& this.call.ai.body[key] != ''
		) {
			return this.call.ai.body[key]
		}

		return null
	}

	fullName() {
		let name = ''

		if (this.contact != null) {
			name = this.contact.first_name

			if (this.contact.last_name) {
				name += ' ' + this.contact.last_name
			}

			return name
		}

		if (this.getAi('first_name') != null) {
			name = this.getAi('first_name')

			if (this.getAi('last_name') != null) {
				name += ' ' + this.getAi('last_name')
			}
		}

		if (name == '') {
			return this.call_id != null ? 'Unknown caller' : this.email
		}

		return name
	}

	hasAddress() {
		return this.getAi('address_line_1') || this.getAi('address_line_2') || this.getAi('address_line_3') || this.getAi('postcode')
	}

	postcodeFormatted() {
		if (this.postcode == null || this.postcode == '') {
			return null
		}

		return toNormalised(this.postcode)
	}

	getCall() {
		if (this.call != null) {
			return this.call
		}

		if (this.old_recording_url != null) {
			return {
				recording_url: this.old_recording_url,
				recording_duration: this.old_duration,
			}
		}

		return null
	}

	getStatus() {
		return this.status_text
	}

	getStatusColor() {
		switch (true) {
			case this.contact != null && this.contact.deleted_at == null && this.contact.archived_at != null:
			case this.status == 2:
				return 'text-grey-800 stroke-grey-800'
				break
			case this.contact != null && this.contact.deleted_at == null:
				return 'text-green-600 stroke-green-600'
				break
			case this.status == 1:
				return 'text-red-700 stroke-red-700'
				break
			case this.status_text == 'cold':
				return 'text-blue-700 stroke-blue-700'
				break
			default:
				return 'text-red-600 stroke-red-600'
		}
	}

	e164ToNumber(n) {
		if (n == null) {
			return null
		}

		n = n.replace('+44', '0')

		return n.substr(0, 5) + ' ' + n.substr(5, 3) + ' ' + n.substr(8, 3)
	}

	unmergeFromContact() {
		let name = this.contact.first_name
		name = this.contact.last_name != '' ? name + ' ' + this.contact.last_name : name

		this.$vue.$pop('confirm', {
			options: {
				action: '/actions/lead-remove-from-contact?lead_id=' + this.id,
				message: 'Are you sure you want to remove this lead from your prospect ' + name + '?',
				button: 'Remove lead',
				method: 'POST',
				head: 'Remove lead from prospect',
			},
		})
	}

	aiValidate() {
		return {
			first_name: 'First name',
			last_name: 'Surname',
			address_line_1: 'Address line 1',
			address_line_2: 'Address line 2',
			town: 'City/town',
			postcode: 'Post code',
			email: 'Email address',
			phone_number: 'Phone number',
			title: 'Category',
			description: 'Description',
		}
	}

	removeLeadFromContact(contact_id) {
		this.vue.$axios
			.post('/actions/lead-remove-from-contact', {
				lead_id: this.id,
				contact_id: contact_id,
			})
			.then(() => {
				this.vue.$event.$emit('timeline-refresh')
			})
	}

	timeline(user) {
		let t = this._timeline(user)
		let c = this.getCall()
		let what = ' new lead'
		let icon = 'IconLeadCircle'
		let options = {}

		console.log(this)

		// let title = 'You received a' + what + ' from ' + (c != null ? this.vue.$help.e164ToNumber(this.phone_number) : this.first_name)
		// let title = 'You received a' + what + ' from ' + this.timelineOrigin.fullName()
		let title = 'You received a' + what;
		

		// if (this.timelineOrigin != null && this.timelineOrigin?.origin?.id != this.id && this.parent_id == null) {
		// 	title = 'You merged a lead with ' + this.timelineOrigin.fullName()
		// 	// icon = 'IconLeadDraftCircle'
		// 	options = {
		// 		options: {
		// 			'Unmerge lead': () => this.removeLeadFromContact(this.timelineOrigin.id),
		// 		},
		// 	}
		// }

		// if (this.vue.$moment(this.created_at).unix() > this.vue.$moment(this.modelCreated).unix() && c != null) {
		// 	return c.timeline(user)
		// }

		return {
			// title: 'You received a new lead from ' + new Contact(t.contact).fullName(),
			title: title,
			description: c != null ? 'No category' : this.title,
			created_at: this.created_at,
			icon: icon,
			...options,
			breakdown:
				c != null
					? {
							'Call recording': c,
							'Call duration': this.vue.$help.fmtMSS(c.recording_duration),
							'Call from': this.vue.$help.e164ToNumber(c.to),
							'Call to': this.vue.$help.e164ToNumber(c.number?.number),

							'Lead category': this.getAi('title') ?? 'No category',
							'Lead summary': this.getAi('description'),
							'First name': this.getAi('first_name'),
							'Last name': this.getAi('last_name'),
							'Email address': this.getAi('email'),
							'Address line 1': this.getAi('address_line_1'),
							'Address line 2': this.getAi('address_line_2'),
							'Address line 3': this.getAi('address_line_3'),
							'City / town': this.getAi('town'),
							// 'Lead transcript': this.getCall().assembly_ai_response,
							//'Phone number': this.vue.$help.e164ToNumber(this.phone_number),
							'Post code': this.getAi('postcode'),
						}
					: {
							'Lead category': this.title ?? 'No category',
							'Lead description': this.description,
							'First name': this.first_name,
							'Last name': this.last_name,
							'Email address': this.email,
							'Phone number': this.vue.$help.e164ToNumber(this.phone_number),
							'Address line 1': this.vue.$help.default(this.address_line_1),
							'Address line 2': this.vue.$help.default(this.address_line_2),
							'Address line 3': this.vue.$help.default(this.address_line_3),
							'City / town': this.vue.$help.default(this.town),
							'Post code': this.postcodeFormatted(),
						},
		}
	}
}
